/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";

import Layout from "../../../../components/layout/Layout";
import Switch from "../../../../components/form/Switch";
import InputText from "../../../../components/form/InputText";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import Skeleton from "../../../../components/form/Skeleton";
import DatePickerUi from '../../../../components/form/DatePickerUi';
import validator from "./validatortransport";
import AutoComplete from "../../../../components/form/AutoComplete";
import FilesModalTransport from "./FilesModalTransport";
import SaveIcon from '@mui/icons-material/Save';
import { useCanView } from "../../../../config/hook/UserPermissions";

import { getProviderId } from "../../../../store/masters/thunk/provider/getId";
import { getTransportId } from "../../../../store/masters/thunk/transport/getId";
import { postTransport } from "../../../../store/masters/thunk/transport/post";
import { putTransport } from "../../../../store/masters/thunk/transport/put";
import { postFilesTransport } from "../../../../store/masters/thunk/filesTransport/post";
import { deleteFilesTransport } from "../../../../store/masters/thunk/filesTransport/delete";

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("supplierTransport");
    const { id } = useParams();
    const { transportid } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

    const user = useSelector(state => state.auth.login.dataUser);
    const current = useSelector((state) => state.masters.provider.detail);
    const put = useSelector(state => state.masters.transport.put);
    const post = useSelector(state => state.masters.transport.post);
    const postTransportFile = useSelector(state => state.masters.fileTransport.post);
    const DeleteTransportFile = useSelector(state => state.masters.fileTransport.delete);
    const canView = useCanView();

    const [showGalery, setShowGalery] = useState(false);

    const transportFuelType = __(`transportFuelType`, { returnObjects: true });
    const transportTemperature = __(`transportDivision`, { returnObjects: true });

    //Datos del LocalStorage
    const userData = JSON.parse(localStorage.getItem('userData'));

    //inicializamos los valores que estaran en los combobox
    const divisions = map(userData?.divisions, ({ divisionId, divisionName }) => ({
       value: divisionId,
       label: divisionName,   
        }));

    const transportTypes = map(userData?.transportTypes, ({ idTransportType, description }) => ({
        value: idTransportType,
        label: description,
    }))


    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

     const HandleModification = (documentName) => {
        dispatch(deleteFilesTransport(documentName));
    }

    const HandleUploadFile = (file) => {
        dispatch(postFilesTransport(file));
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/masters/providers/${id}/transport/${get(post, "id")}`); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
        if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
        if (get(DeleteTransportFile, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
        if (get(postTransportFile, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
    }, [put, post, postTransportFile, DeleteTransportFile])

    useEffect(() => {
        if (!!id) {
            dispatch(getTransportId({ id }))
        }
    }, [dispatch, id])

    const getData = () => {
        dispatch(getProviderId({ id }));
      };
    
      const reload = () => getData()

      const selected = current?.data?.transports?.length > 0 ? current.data.transports.filter(e => e.idTransport == transportid) : [];

    const onSubmit = (values) => {
        if (canView("MAESTROS/PROVEEDORES/CAMIONES", "update")) {
            const baseBody = {
                idProvider: Number(id),
                name: String(get(values, "name", "")),
                numberPlate: String(get(values, "numberPlate", "")),
                vin: String(get(values, "vin", "")),
                description: String(get(values, "description", "")),
                kiloXGallon: Number(get(values, "kiloXGallon", "")),
                isActive: Boolean(get(values, "isActive", "")),
                idTransportType: Number(get(values, "idTransportType")),
                divisionId: Number(get(values, "division")),
                idTemperature: Number(get(values, "temperature")),
                idTransportFuelType: Number(get(values, "idTransportFuelType")),
                idUser: Number(get(values, "idUser")),
                transportBrand: String(get(values, "transportBrand", "")),
                dateExpiration: get(values, "dateExpiration", ""),
                datePermission: get(values, "datePermission", ""),
                isOutSourced: Boolean(get(values, "isOutsourced", "")),
            }

            if (transportid) {
                dispatch(putTransport({ idTransport: Number(transportid), ...baseBody }))
            } else {
                dispatch(postTransport(baseBody))
            }
        } else { 
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar el camión del proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }


    const initialValues = {
        isActive: transportid ? get(selected[0], "isActive", "") : true,
        isOutsourced: transportid ? get(selected[0], "isOutSourced", "") : true,

        numberPlate: transportid ? get(selected[0], "numberPlate", "") : "",
        name: transportid ? get(selected[0], "name", "") : "",
        vin: transportid ? get(selected[0], "vin", "") : "",
        description: transportid ? get(selected[0], "description", "") : "",
        kiloXGallon: transportid ? get(selected[0], "kiloXGallon", "") : "",
        transportBrand: transportid ? get(selected[0], "transportBrand", "") : "",
        dateExpiration: transportid ? get(selected[0], "dateExpiration", "") : new Date(),
        datePermission: transportid ? get(selected[0], "datePermission", "") : new Date(),
        division: transportid ? get(selected[0], "divisionId", "") : "",
        idTransportType: transportid ? get(selected[0], "idTransportType", "") : "", 
        temperature: transportid ? get(find(transportTemperature, ({ value }) => value === get(selected[0], "idTemperature", "")), "value") : "",
        idTransportFuelType: transportid ? get(find(transportFuelType, ({ value }) => value === get(selected[0], "idTransportFuelType", "")), "value") : "",

        idUser: get(user, "idUser"),
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.edit.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading") || get(postTransportFile, "isSuccess")
                ? (
                    <Skeleton />
                ) : (
                    <Formik initialValues={initialValues} 
                    validationSchema={validator(__)} 
                    onSubmit={onSubmit}>
                        {formik => (
                            <form onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='p-4'>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                                        { transportid ? 
                                            <Button className='w-[100px] min-w-[100px]' variant='text' color="secondary" onClick={() => {
                                                if (canView("MAESTROS/PROVEEDORES/CAMIONES/ADJUNTOS", "watch")) {
                                                    setShowGalery(true)
                                                } else {
                                                    setAlert({
                                                        open: true,
                                                        title: "Permiso Denegado.",
                                                        subtitle: (<ul> • No tienes permiso para ver los adjuntos del camión del proveedor.</ul>),
                                                        type: "error",
                                                        btn: __(`${module}.actions.close`),
                                                        func: closeAlert
                                                    })
                                                }
                                            }} disabled={get(put, "isLoading")} >
                                                <div className='whitespace-nowrap'>Ver Adjuntos</div>
                                            </Button> : (<div></div>)
                                        } 
                                        <LoadingButton className='w-[100px] min-w-[100px]' startIcon={<SaveIcon/>} variant="contained" color="secondary" type="submit" loading={get(post, "isLoading") || get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                        <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary"  onClick={() => navigate(`/masters/providers/${get(current, "data.id")}`, { state: { tab: 2 } })}  disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                    </Stack>
                                </Paper>

                                <Paper className='mt-4'>
                                    <Grid container className='p-4' spacing={2}>
                                        <Grid item xs={9.5}>
                                            <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                        </Grid>
                                        <Grid item xs={1.5} container justifyContent="right" >
                                            <Switch formik={formik} name="isOutsourced" __={__} />
                                        </Grid>
                                        <Grid item xs={1} container justifyContent="right" >
                                            <Switch formik={formik} name="isActive" __={__} />
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="numberPlate"
                                                    label={__(`form.numberPlate.label`)}
                                                    placeholder={__(`form.numberPlate.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="name"
                                                    label={__(`form.name.label`)}
                                                    placeholder={__(`form.name.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="vin"
                                                    label={__(`form.vin.label`)}
                                                    placeholder={__(`form.vin.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="transportBrand"
                                                    label={__(`form.transportBrand.label`)}
                                                    placeholder={__(`form.transportBrand.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <AutoComplete
                                                    name="division"
                                                    formik={formik}
                                                    label={__(`form.division.label`)}
                                                    placeholder={__(`form.division.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={divisions}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <AutoComplete
                                                    name={"temperature"}
                                                    formik={formik}
                                                    label={__(`form.temperature.label`)}
                                                    placeholder={__(`form.temperature.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={transportTemperature}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <AutoComplete
                                                    name={"idTransportFuelType"}
                                                    formik={formik}
                                                    label={__(`form.idTransportFuelType.label`)}
                                                    placeholder={__(`form.idTransportFuelType.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={transportFuelType}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="kiloXGallon"
                                                    label={__(`form.kiloXGallon.label`)}
                                                    placeholder={__(`form.kiloXGallon.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    type="number"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <AutoComplete
                                                    formik={formik}
                                                    name="idTransportType"
                                                    label={__(`form.idTransportType.label`)}
                                                    placeholder={__(`form.idTransportType.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={transportTypes}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <DatePickerUi
                                                    formik={formik}
                                                    name="dateExpiration"
                                                    label={__(`form.dateExpiration.label`)}
                                                    placeholder={__(`form.dateExpiration.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <DatePickerUi
                                                    formik={formik}
                                                    name="datePermission"
                                                    label={__(`form.datePermission.label`)}
                                                    placeholder={__(`form.datePermission.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <InputText
                                                    formik={formik}
                                                    name="description"
                                                    label={__(`form.description.label`)}
                                                    placeholder={__(`form.description.placeholder`)}
                                                    disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    multiline
                                                    rows={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
            <FilesModalTransport
                __={__}
                open={showGalery}
                close={() => setShowGalery(false)}
                onModification = {HandleModification}
                onUploadFile = {HandleUploadFile}
            />
        </Layout>
    )
}

export default NewEdit